module.exports = __webpack_public_path__ + "img/hontai_PeachPink.719d2b3a.png";